import { render } from "./EditorImagePopup.vue?vue&type=template&id=5605a07d"
import script from "./EditorImagePopup.vue?vue&type=script&lang=js"
export * from "./EditorImagePopup.vue?vue&type=script&lang=js"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__